import { render, staticRenderFns } from "./SafteList.vue?vue&type=template&id=3a1844f2&"
import script from "./SafteList.vue?vue&type=script&lang=js&"
export * from "./SafteList.vue?vue&type=script&lang=js&"
import style0 from "./SafteList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports